import { useState } from "react";
import { toast } from "sonner";
import { TICKETS } from "../../data/adminData";
import { PageTitle, Table, Badge, Btn, dt } from "./ui";

const SCOLOR = { "Atvērts": "red", "Procesā": "amber", "Atbildēts": "black", "Aizvērts": "gray" };
const PCOLOR = { "Augsta": "red", "Vidēja": "amber", "Zema": "gray" };

export default function Tickets() {
  const [list, setList] = useState(TICKETS);
  const setStatus = (id, status) => {
    setList((p) => p.map((t) => (t.id === id ? { ...t, status } : t)));
    toast.success(`Pieteikums ${id}: ${status} (DEMO)`);
  };
  return (
    <div data-testid="admin-tickets">
      <PageTitle>Atbalsta pieteikumi ({list.length}) <span className="text-sm font-semibold text-[#6B6B6B] normal-case">· {list.filter((t) => t.status === "Atvērts").length} atvērti</span></PageTitle>
      <Table head={["Nr.", "Tēma", "Klients", "Prioritāte", "Datums", "Statuss", "Darbības"]} minWidth="860px">
        {list.map((t) => (
          <tr key={t.id} className="border-b border-[#F5F5F5] hover:bg-[#F5F5F5]" data-testid={`ticket-row-${t.id}`}>
            <td className="p-3 font-bold">{t.id}</td>
            <td className="font-semibold max-w-[280px] truncate">{t.subject}</td>
            <td>{t.customer}</td>
            <td><Badge color={PCOLOR[t.priority]}>{t.priority}</Badge></td>
            <td className="text-[#6B6B6B]">{dt(t.date)}</td>
            <td><Badge color={SCOLOR[t.status]}>{t.status}</Badge></td>
            <td className="p-3">
              <div className="flex gap-1.5">
                {t.status !== "Aizvērts" && <Btn onClick={() => toast.success("Atbilde nosūtīta (DEMO)", { description: `Klientam: ${t.customer}` })} data-testid={`ticket-reply-${t.id}`}>Atbildēt</Btn>}
                {t.status !== "Aizvērts" && <Btn variant="outline" onClick={() => setStatus(t.id, "Aizvērts")} data-testid={`ticket-close-${t.id}`}>Aizvērt</Btn>}
              </div>
            </td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
